export interface PagePreferenceProvider {
  page?: string
  element?: string
  preference?: any

  load: () => any | Promise<any>
  save: (preference: any) => any | Promise<any>
  reset: () => void | Promise<void>
}
